module.exports = __webpack_public_path__ + "img/trine-beder-john-4.56ee2415.png";